import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const MobilePageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const prevPath = useRef(pathname);

  useEffect(() => {
    if (prevPath.current !== pathname) {
      setIsVisible(false);
      prevPath.current = pathname;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setIsVisible(true));
      });
    } else {
      setIsVisible(true);
    }
  }, [pathname]);

  return (
    <div
      className={`transition-opacity duration-300 ease-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {children}
    </div>
  );
};

export default MobilePageTransition;
